import { render, staticRenderFns } from "./BigParticipant.vue?vue&type=template&id=3952923c&scoped=true&"
import script from "./BigParticipant.vue?vue&type=script&lang=js&"
export * from "./BigParticipant.vue?vue&type=script&lang=js&"
import style0 from "./BigParticipant.vue?vue&type=style&index=0&id=3952923c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952923c",
  null
  
)

export default component.exports